/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react"

function useImportFile() {
    const reader = new FileReader()
    
    return useCallback(async (file) => {
        return new Promise((resolve, reject) => {
            reader.readAsDataURL(file)
            reader.onloadend = async () => {
                resolve(reader.result)
            }
            reader.onerror = async () => {
                reject("Erro ao ler o arquivo.")
            }
        })
    }, [])
}

export default useImportFile